import { jsx as _jsx } from "preact/jsx-runtime";
import { SignInBoldImmersive } from './sign-in';
export function SignIn() {
    return _jsx(SignInBoldImmersive, {});
}
